import type { FlexProps, TextProps } from '@chakra-ui/react'
import { Flex, Text } from '@chakra-ui/react'
import type { ReactNode } from 'react'

export interface RecapTableItemProps extends FlexProps {
  label: string | ReactNode
  value?: string
  labelProps?: TextProps
  valueProps?: TextProps
}

export const RecapTableItem = ({
  label,
  value,
  labelProps,
  valueProps,
  sx,
  ...rest
}: RecapTableItemProps) => {
  return (
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        // flexWrap: 'wrap',
        fontSize: 'sm',
        ...sx,
      }}
      {...rest}
    >
      {typeof label === 'string' && (
        <Text
          {...labelProps}
          sx={{ fontSize: 'sm', fontWeight: 'bold', ...labelProps?.sx }}
        >
          {label}
        </Text>
      )}

      {typeof label !== 'string' && label}

      <Text
        {...valueProps}
        sx={{
          fontSize: 'sm', fontWeight: 'bold', ml: 'auto', minW: 20, textAlign: 'right'
          , ...valueProps?.sx
        }}
      >
        {value}
      </Text>
    </Flex>
  )
}
